
import { VariablesGlobales } from '../../providers/variables-globales';
import { Consultas } from '../../providers/consultas';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, App } from 'ionic-angular';

import { BuscadorPage } from '../buscador/buscador';

import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import View from 'ol/View';

import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import { Fill, Stroke, Style} from 'ol/style.js';
import TopoJSON from 'ol/format/TopoJSON.js';

import { toLonLat, transform } from 'ol/proj';
import { ListaPueblosPage } from '../lista-pueblos/lista-pueblos';
import { Provincia } from '../../models/provincia.model';
import { ListaProvinciasPage } from '../lista-provincias/lista-provincias';

/**
 * Generated class for the MapaProvinciasPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-mapa-provincias',
  templateUrl: 'mapa-provincias.html',
  providers: [ Consultas ]
})
export class MapaProvinciasPage {
  public provincias:Array<Provincia>;
  public loader: any;
  public pueblo: string;
  public poblacion: any;

  featureStyle = new Style({
    fill: new Fill({
      color: 'rgb(0,143,255,0.2)'
    }),
    stroke: new Stroke({
      color: 'black'
    })
  });
  defaultStyle = new Style({
    stroke: new Stroke({
      color: 'black'
    }),
  });

  sourceVector = new VectorSource({
    url: 'assets/maps/provinces.json',
    format: new TopoJSON(),
  });
  vectorLayer = new VectorLayer({
    source: this.sourceVector,
    style: this.defaultStyle
  });

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public consultas: Consultas,
    public loadingCtrl: LoadingController,
    public global: VariablesGlobales,
    private app: App,
    private toastCtrl:ToastController) {
  }

  ionViewDidLoad() {

  }

  vistaLista(){
    this.navCtrl.setRoot(ListaProvinciasPage,);
  }

  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }

  ngOnInit(){
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
        this.consultas.getProvinciasComunidad("").subscribe(x=>
          {
            this.provincias = x;
            this.styleProvincias();
            this.loader.dismiss();
          },error=>console.error()
          );
    });

    const osm = new TileLayer({
      source: new OSM({}),
    });

    const map = new Map({

      layers: [osm, this.vectorLayer],
      target: 'map',
      view: new View({
        center: [-506743.4480196573, 4530550.177757272],
        zoom: 5.5,
        constrainResolution: true,
        minZoom: 5.5,
      }),
    });

    map.on('click', (evt) => {
      const coordinates = transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326');
      const latLong = toLonLat(evt.coordinate)
      this.reverseGeocode(latLong);
    });

        //Update size of map to fix load error
		setTimeout(() => {
			map.updateSize();
		}, 1500);
  }

  /*styleFunction = (feature, resolution) =>{
    const defaultStyle = new Style({
      stroke: new Stroke({
        color: 'black'
      }),
    });

    const featureStyle = new Style({
      fill: new Fill({
        color: 'rgb(0,143,255,0.2)'
      })
    });
    // get the incomeLevel from the feature properties
    const provincia = feature.get('name');
    // if there is no level or its one we don't recognize,
    // return the default style (in an array!)
    if (this.provincias && this.provincias.find(x=> x.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()) == provincia.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()) {
      return [featureStyle];
    }
    // at this point, the style for the current level is in the cache
    // so return it (as an array!)
    return defaultStyle;
  }*/

  styleProvincias(){
    this.vectorLayer.getSource().forEachFeature((feature)=>{
      // get the incomeLevel from the feature properties
        const provincia = feature.get('name');

        if(provincia){
          // if there is no level or its one we don't recognize,
          // return the default style (in an array!)
          if (this.provincias && this.provincias.find(x=> x.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() == provincia.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())) {

            feature.setStyle(this.featureStyle)
          }
        }
    });
  }

  reverseGeocode(coords) {
    fetch('https://nominatim.openstreetmap.org/reverse?format=json&lon=' + coords[0] + '&lat=' + coords[1])
      .then((response) =>{
             return response.json();
         }).then((json) =>{
             //console.log(json);
             if(json && json.address && json.address.state_district){
             const provincia = this.provincias.find(x=>
              x.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
              ==
              json.address.state_district.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
              );
             console.log(provincia);
              if(provincia){
                this.goToPuebloMenu(provincia.id_provincia);
              }else{
                let toast = this.toastCtrl.create({
                  message: 'Aún no trabajamos en esta provincia',
                  duration: 3000,
                  position: 'bottom'
                });

                toast.onDidDismiss(() => {
                  console.log('Dismissed toast');
                });

                toast.present();
              }
             }
         });
 }


  goToPuebloMenu(idProvincia){
    this.navCtrl.push(ListaPueblosPage,{idProvincia});
  }
}



// WEBPACK FOOTER //
// ./src/pages/mapa-provincias/mapa-provincias.ts